import React from "react";
import {
    Badge
} from 'reactstrap';
import {Link} from 'react-router-dom';

//Icons
import ToolTipItem from "../utils/tooltip";
import {appHelpers} from "../../_helpers";
import ViewIcon from 'react-icons/lib/md/remove-red-eye';
//Icons
import ServerPaginatedTable from "../utils/pagination.server";

const IATAValidationTableStructure = ({data, interpretUserId, interpretAirline, pageIndex, interpretAirport}) => (
    <table className="table table-striped table-hover">
        <thead>
        <tr>
            <th>
                <span>S/N</span>
            </th>
            <th>
                <span>Airline</span>
            </th>
            <th>
                <span>Departure Airport</span>
            </th>
            <th>
                <span>Flight Date</span>
            </th>
            <th>
                <span>Status</span>
            </th>
            <th>
                <span>Created By</span>
            </th>
            <th>
                <span>Created On</span>
            </th>
            <th>
                Action
            </th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, i) => <tr key={i}>
            <td className="text-capitalize">{ `${pageIndex + i + 1}`  }</td>
            <td className="text-capitalize">{`${interpretAirline(item.AirlineId)}`}</td>
            <td className="text-capitalize">{`${interpretAirport(item.DepartureAirportId)}`}</td>
            <td className="text-capitalize">{`${appHelpers.formatDate(item.StartFlightDate)}`}</td>
            {/*<td className="text-capitalize">{`${appHelpers.formatDate(item.EndFlightDate)}`}</td>*/}
            <td className="text-capitalize">
                {
                    (item.ValidationStatus === 0) &&
                    <Badge color='info'>&nbsp;{item.WorkflowStatus}&nbsp;</Badge>
                }
                {
                    (item.ValidationStatus === 1) &&
                    <Badge color='success'>&nbsp;Completed&nbsp;</Badge>
                }
            </td>
            <td>{`${interpretUserId(item.CreatedBy)}`}</td>
            <td className="text-capitalize">{`${appHelpers.formatDate(item.CreatedOn)}`}</td>
            <td>
                <Link to={`/iata-validation-page/${item.Id}`} className="text-primary pointer">
                    <ToolTipItem key={i + 'viewValidation'} title={<ViewIcon size="15" color="#43a8df"/>} content='View records' id={i + 'viewValidation'}/>
                </Link>&nbsp;
            </td>
        </tr>)}
        </tbody>
    </table>
);

class IataValidationRecords extends React.Component {
    render() {
        let { data, interpretAirline, interpretAirport, interpretUserId, currentPage, pageDataCallback, pageSize, totalRecordsCount } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;
        return (
            <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallback} target={<IATAValidationTableStructure interpretAirport={interpretAirport} interpretAirline={interpretAirline} interpretUserId={interpretUserId} pageIndex={pageIndex} data={data}/>} pageSize={pageSize} totalCount={ totalRecordsCount }/>
        )
    }
}
export default IataValidationRecords;



// WEBPACK FOOTER //
// ./src/views/iataValidation/iata-validation-records.js